import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { getDollarFormat } from 'utils/helpers';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DoneIcon from '@mui/icons-material/Done';
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import CloseIcon from '@mui/icons-material/Close';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

import NoDataMsg from 'library/noData'


import { getOrderStatusIcon } from 'utils/mappers';


const Body = ({ transactionDetails, beginDate, endDate, transT }) => {
    // console.log(transactionDetails, beginDate, endDate, transT);
    return(
    <div id="TransactionReport">
        {
            transactionDetails.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                //If there's DATA
                <div>
                    <div className="row m-0">
                        <div className="row m-0 list_header text-center">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM D, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM D, YYYY')}</b> : moment().format('MMMM D, YYYY')}</p>
                                : moment().format('MMMM D, YYYY')}
                        </div>
                    </div>

                    <div>

                        {
                            transactionDetails.map((item, index) => {

                                const productTotal = item.openedProducts + item.soldProducts + item.voidedProducts + item.cancelledProducts + item.returnedProducts;

                                return (
                                    <div className="row m-0 pb-2 pt-2 odd_bgcolor" key={index}>
                                        <div className="col-lg-2 col-md-2 col-sm-6 col-xs-6 border-right mb_xs">
                                            <p className="xs-font"><b><i>Order</i></b></p>
                                            <p className="m-0 fw_bold"><Link to={`/admin/orders/detail/${item.orderNumber}`} target="_blank">#{item.orderNumber}</Link></p>
                                            <p className="m-0 whiteColorFont"><i>{moment(item.createdDate).format('MMM D, YYYY')}</i></p>
                                            {getOrderStatusIcon(item.status)}
                                        </div> {/* Column Orders */}

                                        <div className="col-lg-2 col-md-2 col-sm-6 col-xs-6 border-right mb_xs">
                                            <p className="xs-font mb-1"><b><i>Employee</i></b></p>
                                            <h4 className="grey-text cap_text mt-0">{item.employee}</h4>
                                            <p className="xs-font m-0">Approved by: <i className="cap_text">{item.approvalUser}</i></p>
                                            <p className="xs-font m-0">Type: {item.approvalType}</p>
                                            {item.discountreason ? <p className="xs-font">Reason: {item.discountreason}</p> : <span></span>}
                                            {item.taxExemptAll || item.useFNTax ? <p className="xs-font"> Tax Exempt: {item.taxExemptAll ? "All" : "FN tax"}</p> : null}
                                        </div> {/* Column Orders */}

                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 text-center border-right mb_xs">
                                            <p className="xs-font text-left float-L purpleText"><b><i>Product Status Details</i></b></p>
                                            <p className="xs-font text-left float-R purpleText"><b><i>Total Products: {productTotal}</i></b></p>
                                            <div className="row col-lg-12">
                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4 m-0 p-0 clear-both">
                                                    <h3 className="m-0 fw_bold grey-text">{item.openedProducts}</h3>
                                                    <h5 className="orange-text fw_bold mt-0 size_1_5ch d-flex">
                                                        <span className="sm_icon"><OpenInNewIcon /></span> Opened
                                                    </h5>
                                                </div>
                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-4 m-0 p-0">
                                                    <h3 className="m-0 fw_bold grey-text">{item.soldProducts}</h3>
                                                    <h5 className="green-text fw_bold mt-0 size_1_5ch">
                                                        <span className="sm_icon"><DoneIcon /></span> Completed
                                                    </h5>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-4 m-0 p-0">
                                                    <h3 className="m-0 fw_bold grey-text">{item.voidedProducts}</h3>
                                                    <h5 className="blue-text fw_bold mt-0 size_1_5ch">
                                                        <span className="sm_icon"><RemoveShoppingCartIcon /></span> Voided
                                                    </h5>
                                                </div>
                                                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6 m-0 p-0">
                                                    <h3 className="m-0 fw_bold grey-text">{item.cancelledProducts}</h3>
                                                    <h5 className="danger fw_bold mt-0 size_1_5ch">
                                                        <span className="sm_icon"><CloseIcon /></span> Cancelled
                                                    </h5>
                                                </div>
                                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-6 m-0 p-0">
                                                    <h3 className="m-0 fw_bold grey-text">{item.returnedProducts}</h3>
                                                    <h5 className="grey-text fw_bold mt-0 size_1_5ch">
                                                        <span className="sm_icon"><MonetizationOnIcon /></span> Refunded
                                                    </h5>
                                                </div>

                                                {item.discountComment ?
                                                    <div className="col-lg-12 col-md-2 col-sm-2 col-xs-6 m-0 p-0">
                                                        <h5 className="grey-text fw_bold mt-0 size_1_5ch">Discount Note: {item.discountComment}</h5>
                                                    </div>
                                                    : <span></span>
                                                }
                                            </div>    
                                        </div> {/* Column Orders */}

                                        <div className="col-lg- col-md-2 col-sm-12 col-xs-12 text-right center_xs mb_xs">
                                            <p className="xs-font m-0 purpleText"><b><i>Total Amount</i></b></p>
                                            <p className="money db-data m-0">{getDollarFormat(item.total)}</p>
                                            <p className="xs-font m-0 blue-text">Tax: {getDollarFormat(item.taxes)}</p>
                                            <p className="xs-font m-0 blue-text">Delivery Fees: {getDollarFormat(item.deliveryFees)}</p>
                                            <p className="xs-font m-0 blue-text">Payment Type: {item.paymentType != null ? item.paymentType : 'None'}</p>
                                            {item.taxExemptAll == true ? <p className="xs-font m-0 danger">TaxExempt: -{getDollarFormat(item.taxes)}</p> : ''}
                                            <p className="xs-font m-0 danger">Discount $: -{getDollarFormat(item.discount)}</p>
                                            <p className="xs-font m-0 danger">Discount %: {item.discount != 0 ? Math.round(item.discount / item.subTotal * 100) : 0}%</p>
                                            <p className="xs-font m-0 danger">MemberSaving $: -{getDollarFormat(item.memberSavingTotal)}</p>
                                            {item.tipAmount ? <p className="xs-font m-0 blue-text">Tip: {getDollarFormat(item.tipAmount)}</p> : ''}
                                            {item.reason ? <p className="xs-font m-0 danger">Refund Reason: {item.reason}</p> : ''}
                                        </div> {/* Column Orders */}
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
        }
    </div>
)
};
export default Body;